import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'
import { HelpSection } from 'legacy/lut/components/widgets/public/partner360/helpButton'
import { getLinkBySectionAndProgramType } from 'legacy/lut/components/widgets/public/partner360/helpButton/helpers/getLinkBySectionAndProgramType'
import { getStrSeparatedByUpperCase } from 'legacy/lut/components/widgets/public/partner360/helpers/getStrSeparatedByUpperCase'
import type { FC, JSX } from 'react'

import { Translation } from 'cng-common/features/translations/components/translation'
import { ModalDialog } from 'core-components/library/modalDialog'
import type { IModalContent } from 'core-components/library/modalDialog/models/IModalContent'
import { Tooltip } from 'core-components/library/tooltip'
import { SupportButton } from 'partner360/components/supportButton'

import * as TRANSLATION_KEYS from '../../../widgets/devicesInfo/partnerDevicesInfo/translations'
import type { PartnerDevicesInfoModalProps } from '../model/types'

import { PartnerDevicesInfoFeatureWithSummary } from './PartnerDevicesInfoFeature'

import styles from './PartnerDevicesInfoModal.module.scss'

type PartnerDevicesInfoModalContentProps = IModalContent &
  Omit<PartnerDevicesInfoModalProps, 'show'>

const HelpIcon = ({ offering }: { offering: string }) => {
  const link = getLinkBySectionAndProgramType({
    section: HelpSection.DeviceInfo,
    programType: offering as ProgramTypes,
  })

  if (!link) {
    return null
  }

  return (
    <Tooltip
      tipContent={() => (
        <Translation
          text={getStrSeparatedByUpperCase(`jbp-help-btn-for-section${HelpSection.DeviceInfo}`)}
        />
      )}
    >
      <SupportButton
        variant="text"
        className={styles.helpIcon}
        href={link}
        target="_blank"
        rel="noreferrer"
        iconButton="kbase kbase-question"
      />
    </Tooltip>
  )
}

const PartnerDevicesInfoModalContent = ({
  partnerId,
  partnerSummary,
  isEditable,
  fYear,
  offering,
  onClose,
  onConfirmed,
}: PartnerDevicesInfoModalContentProps): JSX.Element => {
  return (
    <div className={styles.content}>
      <PartnerDevicesInfoFeatureWithSummary
        partnerId={partnerSummary?.pid ?? partnerId}
        isEditable={isEditable}
        fYear={fYear}
        offering={offering}
        partnerSummary={partnerSummary}
        onClose={onClose}
        onConfirmed={onConfirmed}
      />
    </div>
  )
}

export const PartnerDevicesInfoModal: FC<PartnerDevicesInfoModalProps> = ({
  show,
  partnerId,
  isEditable,
  fYear,
  offering,
  partnerSummary,
  onClose,
  onConfirmed,
}) => {
  return (
    <ModalDialog
      show={show}
      size="md"
      classes={{ window: styles.window }}
      header={() => (
        <div className={styles.titleWrap}>
          <div className={styles.title}>
            <Translation text={TRANSLATION_KEYS.widgetTitle} span />
          </div>
          <HelpIcon offering={offering} />
        </div>
      )}
      content={PartnerDevicesInfoModalContent}
      contentProps={{
        partnerId,
        isEditable,
        fYear,
        offering,
        partnerSummary,
        onClose,
        onConfirmed,
      }}
      onClose={onClose}
    />
  )
}
